<template>
	<footer class="footer">
    <div class="container">
      <div class="content has-text-centered">
        <p>Powered by <a href="https://devahoy.com" target="_blank">DevAhoy</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
	export default {
		name: 'app-footer'
	}
</script>


<style scoped>
	.footer {
	  padding: 3rem 1.5rem;
	}
</style>


// WEBPACK FOOTER //
// Footer.vue?f1aad606